/**
 * @enum QuickDateOption
 * Defines the available quick date selection options
 */
export enum QuickDateOption {
  LAST_7_DAYS = 'last-7-days',
  LAST_30_DAYS = 'last-30-days',
  THIS_MONTH = 'this-month',
  THIS_YEAR = 'this-year'
}
